import { GET_ALL_MUSICAS_EM_ESPERA, GET_MUSICA_EM_ESPERA_ESPECIFICA } from './mutation-types'

import musicaEmEsperaHttpService from '../_services/musicaEmEsperaHttpService'

export default {
  listarMusicasEmEspera: async ({ commit }) => {
    try {
      const response = await musicaEmEsperaHttpService.getMusicasEmEspera()
      commit(GET_ALL_MUSICAS_EM_ESPERA, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarMusicaEmEspera: async ({ commit }, _id) => {
    try {
      const response = await musicaEmEsperaHttpService.getMusicaEmEspera(_id)
      commit(GET_MUSICA_EM_ESPERA_ESPECIFICA, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
